import { useEffect, useState } from "react";
import HomepageSections from "../components/Home/HomepageSections";

export default function Home() {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    fetch("/data/homepage.json")
      .then((response) => {
        if (!response.ok) throw new Error(`Unable to load homepage: ${response.status}`);
        return response.json();
      })
      .then((data) => setSections(data.sections || []))
      .catch((error) => console.error(error));
  }, []);

  return (
    <main>
      <HomepageSections sections={sections} />
    </main>
  );
}
